import { FormApi, FormState } from 'final-form';

import { GroupType } from 'APP/model/group/groupModel.types';

export interface IGroupFormInitialValues {
  type: GroupType;
  avatarUrl?: string;
  name?: string;
  description?: string;
  deepLinkAlias?: string;
  members?: string[];
}

export type TFormSubmitHandler = (
  data: IGroupFormInitialValues,
  form: FormApi,
  cb: (errors: unknown) => void
) => void;

export type TFormUpdateHandler = (
  state: FormState<IGroupFormInitialValues, IGroupFormInitialValues>
) => void;

export type TSubmitHandler = (data: IGroupFormInitialValues) => unknown;

export enum GroupFormStep {
  Members = 'members',
  GeneralInfo = 'general-info',
}
